import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const CarDetailsStyle = styled.div`
  margin-top: ${theme.grid.spacing.base}px;
  .car-details-box {
    padding: ${theme.grid.spacing.md}px ${theme.grid.spacing.base}px;
    display: flex;
    flex-direction: column;
    color: ${theme.primaryColours.aubergine.main};
  }
  .car-view {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .car-view-section {
    &:not(:last-child) {
      margin-bottom: ${theme.grid.spacing.s}px;
    }
  }
  .car-name {
    text-align: center;
  }
  .car-details-container {
    display: flex;
    flex-direction: column;
  }
  .not-my-car {
    cursor: pointer;
    width: fit-content;
    font-weight: 700;
    font-size: 14px;
    border-bottom: 2px solid ${theme.primaryColours.aubergine.main};
  }
  .expand-container {
    margin-top: ${theme.grid.spacing.s}px;
  }

  @media (max-width: ${theme.grid.resolution.tablet.width}px) {
    .is-tablet {
      display: none;
    }
    .car-view {
      border-bottom: 2px solid ${theme.tints.aubergine};
    }
    .car-details-container {
      margin-top: ${theme.grid.spacing.md}px;
    }
    .reg-wrapper {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }
    .image-wrapper {
      margin-right: ${theme.grid.spacing.s}px;
    }
    .not-my-car {
      margin-bottom: ${theme.grid.spacing.md}px;
    }
  }

  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    margin-top: ${theme.grid.spacing.l}px;
    .is-mobile {
      display: none;
    }
    .car-details-box {
      flex-direction: row;
    }
    .car-view {
      border-right: 1px solid ${theme.tints.aubergine};
      padding: 0 ${theme.grid.spacing.md}px 0 ${theme.grid.spacing.xs}px;
      min-width: calc(100% / 3);
    }
    .car-details-container {
      display: flex;
      flex-direction: row;
      min-width: calc((100% / 3) * 2);
      border-bottom: none;
      border-left: 1px solid ${theme.tints.aubergine};
      .car-details {
        width: 100%;
        padding-left: ${theme.grid.spacing.md}px;
      }
    }
  }
`
